<template>
    <div class="position-box orderStatus">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('bzhlwdtg.title')}}</div>
        </div>
        <div class="cotainer">
            <div class="tab-wrap">
              <ul class="tab-box">
                <li class="tab" :class="{active: tabIdx == 1}" @click="tab(1)">{{$t('bzhlwdtg.tgz')}}</li>
                <li class="tab" :class="{active: tabIdx == 5}" @click="tab(5)">{{$t('gjrz.shz')}}</li>
                <li class="tab" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('bzhlwdtg.ywc')}}</li>
                <li class="tab" :class="{active: tabIdx == 3}" @click="tab(3)">{{$t('tipsNew.shz')}}</li>
                <li class="tab" :class="{active: tabIdx == 4}" @click="tab(4)">{{$t('bzhlwdtg.ysh')}}</li>
                <li class="tab" :class="{active: tabIdx == -1}" @click="tab(-1)">{{$t('tipsNew.yjj')}}</li>
              </ul>
            </div>
            <ul class="ul-box" @scroll="listenScroll">
                <li class="list" v-for="(item,index) in myProfitArr" :key="index">
                    <div class="time" v-if="lang == 'ar'">
                        <div class="btn-sh" v-show="tabIdx == 1" @click.stop="shuhui(item.id)">{{$t('bzhlwdtg.sh')}}</div>
                        <div class="order-box"><div>{{item.no}}</div><img class="icon" style="margin: 0 0 0 .24rem" :src="icon" alt=""></div>
                    </div>
                    <div class="time" v-else>
                        <div class="order-box"><img class="icon" :src="icon" alt=""><div>{{item.no}}</div></div>
                        <div class="btn-sh" v-show="tabIdx == 1" @click.stop="shuhui(item.id)">{{$t('bzhlwdtg.sh')}}</div>
                    </div>
                    <div class="item-box" v-if="lang == 'ar'">
                        <div class="item">
                            <p class="text">{{item.amount}}/{{item.cycle}}</p>
                            <p>{{$t('bzhlwdtg.tgje')}}</p>
                        </div>
                        <div class="item">
                            <p class="text">{{item.rate_win}}</p>
                            <p>{{$t('bzhlwdtg.rsyl')}}(%)</p>
                        </div>
                        <div class="item">
                            <p class="text">{{item.send_fee}}/{{item.shengyu_days}}</p>
                            <p>{{$t('bzhlwdtg.yhl')}}</p>
                        </div>
                        <div class="item">
                            <p class="text">{{item.addtime}}</p>
                            <p>{{$t('bzhlwdtg.xdsj')}}</p>
                        </div>
                    </div>
                    <div class="item-box" v-else>
                        <div class="item">
                            <p>{{$t('bzhlwdtg.tgje')}}</p>
                            <p class="text">{{item.amount}}/{{item.cycle}}</p>
                        </div>
                        <div class="item">
                            <p>{{$t('bzhlwdtg.rsyl')}}(%)</p>
                            <p class="text">{{item.rate_win}}</p>
                        </div>
                        <div class="item">
                            <p>{{$t('bzhlwdtg.yhl')}}</p>
                            <p class="text">{{item.send_fee}}/{{item.shengyu_days}}</p>
                        </div>
                        <div class="item">
                            <p>{{$t('bzhlwdtg.xdsj')}}</p>
                            <p class="text">{{item.addtime}}</p>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <div class="null-box" v-show="hasData">
                <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                <p class="text">{{$t('zwsj.title')}}</p>
            </div>
            <div class="mask" v-show="isShow"></div>
			<div class="alert-pwd-box" v-show="isShow">
				<div class="alert-head">{{$t('tips.qsrjymm')}}</div>
				<img class="close" v-if="!theme" src="@/assets/close2.png" @click="close" alt="">
				<img class="close" v-else src="@/assets/close.png" @click="close" alt="">
				<ul class="pwd-box">
					<li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
				</ul>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'orderStatus',
    data () {
        return {
            uid: '',
            token: '',
            tabIdx: 1,
            isShow: false,
            id: '',
            hasData: false,
            myProfitArr: [],
            tgje: '',
            rsyl: '',
            yhl: '',
            xdsj: '',
            curDataLength: 10,
            theme: false,
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
            currency: '',
            icondft: require('../assets/coin_type.png'),
            icon: '',
            page: 1,
            lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.currency = localStorage.getItem('sbsxbz') || 'USDT';
      this.icon = localStorage.getItem('sbsxIcon') || this.icondft;
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getMyprofit();
    },
    methods: {
       back(){
           this.$router.push('/propagate')
       },
       tab(idx){
           this.tabIdx = idx;
           this.page = 1;
           this.myProfitArr = [];
           this.getMyprofit()
       },
       getMyprofit(){
            let that = this;
            that.isShow = false;
            that.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
            let params = {
                type: that.tabIdx,
                currency: this.currency,
                page: that.page
            }
            this.$ajax.get('/web/getMyprofit',{params}).then((res) => {
                let resData = res.data.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                if(resData.length > 0){
                    that.myProfitArr = that.myProfitArr.concat(resData);
                    that.curDataLength = resData.length;
                }else{
                    that.curDataLength = resData.length;
                }
                if(that.myProfitArr.length > 0){
                    that.hasData = false;
                }else{
                    that.hasData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       shuhui(id){
            this.id = id;
            this.isShow = true;
            this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
        },
        nextFocus(el,index) {
            var dom = document.getElementsByClassName("pwd-input"),
                currInput = dom[index],
                nextInput = dom[index + 1],
                lastInput = dom[index - 1];
            /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
            if(el.keyCode != 8) {
              if(dom[0].value == ''){
                  dom[0].value = this.inputList[0].val = currInput.value;
                  currInput.value = this.inputList[index].val ='';
                  dom[0].blur();
                  dom[1].focus();
              }
              if(currInput.value == '') return;
              if(index < (this.inputList.length - 1)) {
                  nextInput.focus();
              }else {
                  currInput.blur();
              }
            }else{
                if(index != 0) {
                  lastInput.focus();
                }
            }
            let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
            if(password.length == 6){
                let that = this;
                let params = {
                    profit: that.id,
                    layer_loading: false,
                    tpassword: password
                }
                this.$ajax.post('/web/sellProfit',params).then((res) => {
                  let resData = res.data;
                  if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    that.myProfitArr = [];
                    that.page = 1;
                    that.$toast.center(resData.message);
                    that.getMyprofit();
                  }else{
                      that.$toast.center(resData.message);
                      return;
                  }
                }).catch(function(err){
                    console.log(err)
                })
            }else{
                return false;
            }
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyprofit();
                }
            }
        },
       close(){
            this.isShow = false;
            this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
        },
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .tab-wrap{
      padding: 0 .42rem;
      background: #fff;
    }
    .cotainer .tab-box{
      display: flex;
      align-items: stretch;
      align-content: center;
      flex-wrap: nowrap;
      width: 100%;
      background: #fff;
      overflow-x: scroll;
    }
    .cotainer .tab-box::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .cotainer .tab-box .tab{
      position: relative;
      margin: 0 .78rem 0 0;
      padding: .42rem 0;
      color: #000;
      font-size: .36rem;
      white-space: nowrap;
      background: #fff;
      box-sizing: border-box;
      text-align: center;
    }
    .cotainer .tab-box .tab:last-child{
      margin-right: 0;
    }
    .cotainer .tab-box .tab.active{
        color: #588bf8;
        font-size: .42rem;
    }
    .cotainer .tab-box .tab.active::after{
      position: absolute;
      left: 50%;
      bottom: 0;
      content: '';
      width: 0.6rem;
      height: 2px;
      margin-left: -0.3rem;
      border-radius: .06rem;
      background: #588bf8;
    }
    .cotainer .ul-box{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        padding: .3rem;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .cotainer .list{
        margin-bottom: .18rem;
        padding: .42rem .42rem .54rem .42rem;
        background-color: #fff;
        border-radius: .15rem;
    }
    .cotainer .list .time{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: .3rem;
        font-size: .48rem;
        border-bottom: 1px solid #d8d8d8;
    }
    .cotainer .list .time .order-box{
        flex: 1;
        display: flex;
        align-items: center;
    }
    .cotainer .list .time .icon{
        width: .66rem;
        margin-right: .24rem;
    }
    .cotainer .list .item-box .item{
        display: flex;
        justify-content: space-between;
        padding-top: .45rem;
        color: #747F87;
        font-size: .42rem;
    }
    .cotainer .list .item-box .item .text{
        color: #181818;
    }
    .cotainer .list .time .btn-sh{
        color: #0752C0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/orderStatus.vue